
import React, { useState } from 'react';
import { useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../store';
import { fetchFacilityReportStats, selectFacilityReportStats, selectFacilityReportStatsLoading } from '../../modules/facility';
import PerformanceStats from './components/PerformanceStats';
import ShiftHistory from './components/ShiftHistory';
import WorkerAttendance from './components/WorkerAttendance';
import { useSidebar } from '../../context/SidebarContext';
import { useBreadcrumb } from '../../context/BreadcrumbContext';
import {
  PageContainer,
  HeaderSection,
  PageTitle,
  TabPanelBox
} from './styles';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <TabPanelBox>
          {children}
        </TabPanelBox>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const FacilityReport: React.FC = () => {
  const { setActivePage } = useSidebar();
  const { setIsShow } = useBreadcrumb();
  useEffect(() => {
    setActivePage('facility_report');
    setIsShow(false);
  }, [setActivePage, setIsShow]);

  const [value, setValue] = useState(0);
  const dispatch = useDispatch<AppDispatch>();
  const stats = useSelector(selectFacilityReportStats);
  const loading = useSelector(selectFacilityReportStatsLoading);

  useEffect(() => {
    dispatch(fetchFacilityReportStats({}));
  }, [dispatch]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <PageContainer maxWidth="xl">
      <HeaderSection>
        <PageTitle variant="h5">
          Performance Overview
        </PageTitle>
      </HeaderSection>

      <PerformanceStats stats={stats} loading={loading} />

      <Box sx={{ mt: 4 }}>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="report tabs"
              textColor="primary"
              indicatorColor="primary"
              sx={{
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '1rem',
                }
              }}
            >
              <Tab label="Shift History" {...a11yProps(0)} />
              <Tab label="Worker Attendance" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <ShiftHistory />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <WorkerAttendance />
          </CustomTabPanel>
        </Box>
      </Box>
    </PageContainer>
  );
};

export default FacilityReport;
